<template>
  <el-row :gutter="16">
    <el-col :span="6" v-for="item in cards" :key="item.label">
      <el-card>
        <div>{{ item.label }}</div>
        <h2>{{ item.value }}</h2>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { stats } from '../api/merchant';
export default {
  data() {
    return { data: {} };
  },
  computed: {
    cards() {
      return [
        { label: '客服人数', value: this.data.agent_count || 0 },
        { label: '活跃会话', value: this.data.active_conversation_count || 0 },
        { label: '今日消息', value: this.data.today_message_count || 0 },
        { label: '快捷回复', value: this.data.quick_reply_count || 0 }
      ];
    }
  },
  async created() {
    const { data } = await stats();
    this.data = data.data || {};
  }
};
</script>

